module.exports = __webpack_public_path__ + "img/300x250_layout_3.4c67e6be.svg";